import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText.js';

/** Componsante TextAnim de TimTools */
export default class TextAnim {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;
    this.options = {
      repeat: false,
    };

    gsap.registerPlugin(SplitText);

    // this.init();
    document.fonts.ready.then(this.init.bind(this));
  }

  init() {
    this.setOptions();

    this.split = SplitText.create(this.element, {
      mask: 'chars',
      type: 'chars, words',
      autoSplit: true,
    });
    this.initAnim();
    this.initObserver();
  }
  initObserver() {
    const observer = new IntersectionObserver(this.watch.bind(this), {
      rootMargin: '0px 0px 0px 0px',
    });
    observer.observe(this.element);
  }

  initAnim() {
    console.log('initAnim');
    gsap.set(this.split.chars, {
      yPercent: 'random([-100,100])', // animate from 100px below
      autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
    });
  }
  animOut() {
    gsap.to(this.split.chars, {
      duration: 1,
      yPercent: 'random([-100,100])', // animate from 100px below
      autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
      stagger: 0.05, // 0.05 seconds between each
      delay: 0.25,
      ease: 'expo.out',
    });
  }
  animIn() {
    gsap.to(this.split.chars, {
      duration: 1,
      yPercent: 0, // animate from 100px below
      autoAlpha: 1, // fade in from opacity: 0 and visibility: hidden
      stagger: 0.05, // 0.05 seconds between each
      delay: 0.25,
      ease: 'expo.out',
    });
  }
  anim(isAnimIn) {
    const alpha = isAnimIn ? 1 : 0;
    const y = isAnimIn ? 'random([-100,100])' : 0;

    gsap.to(this.split.chars, {
      duration: 1,
      yPercent: y, // animate from 100px below
      autoAlpha: alpha, // fade in from opacity: 0 and visibility: hidden
      stagger: 0.05, // 0.05 seconds between each
      delay: 0.25,
      ease: 'expo.out',
    });
  }

  watch(entries, observer) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;

      if (entry.isIntersecting) {
        this.animIn();
        //this.anim(true)
        if (!this.options.repeat) observer.unobserve(target);
      } else {
        this.animOut();
        // this.anim(false)
      }
    }
  }

  setOptions() {
    if ('repeat' in this.element.dataset) {
      this.options.repeat = true;
    }
  }
}
